const GenreDatas = [
  { genre: "adventure", name: "Adventure" },
  { genre: "action", name: "Action" },
  { genre: "comedy", name: "Comedy" },
  { genre: "sliceoflife", name: "Slice Of Life" },
  { genre: "drama", name: "Drama" },
  { genre: "fantasy", name: "Fantasy" },
  { genre: "supernatural", name: "Super Natural" },
  { genre: "magic", name: "Magic" },
  { genre: "mystery", name: "Mystery" },
  { genre: "horror", name: "Horror" },
  { genre: "psychological", name: "Psychological" },
  { genre: "scifi", name: "Sci-Fi" },
  { genre: "romance", name: "Romance" },
];

export default GenreDatas;
